import { useI18n, useLocaleHead } from "#i18n";
import { useHead } from "#imports";
import { computed, defineComponent, watchEffect } from "vue";
import { Footer } from "~/components/layout/Footer";
import { Header } from "~/components/layout/Header";
import usePageMeta from "~/composables/usePageMeta";
import { useMainStore } from "~/stores/main";

export default defineComponent({
  setup(_props, { slots }) {
    const mainStore = useMainStore();
    const { t } = useI18n();
    const { pageTitle, pageDescription, pageImage } = usePageMeta();

    // Site-wide meta defaults from the CMS globals (pages override non-empty).
    watchEffect(() => {
      const m = mainStore.meta;
      pageTitle.value = m?.metaTitle ?? "";
      pageDescription.value = m?.metaDescription ?? "";
      pageImage.value = m?.ogImage?.[0]?.ogImageUrl ?? "";
    });

    // Locale-aware head: html lang + hreflang alternate links (incl.
    // x-default). Canonical + og:locale stay in usePageMeta (single source),
    // so only the lang attribute and the alternate links are taken from i18n.
    const i18nHead = useLocaleHead({ lang: true, seo: true, dir: false });
    useHead({
      htmlAttrs: {
        lang: computed(() => i18nHead.value.htmlAttrs?.lang ?? "de"),
      },
      link: computed(() =>
        (i18nHead.value.link ?? []).filter((l) => "hreflang" in l),
      ),
    });

    return () => (
      <div class="flex min-h-screen flex-col">
        <a
          href="#main"
          class="sr-only rounded-[5px] focus:not-sr-only focus:absolute focus:top-18 focus:left-18 focus:z-50 focus:bg-purple focus:p-18 focus:text-white"
        >
          {t("common.skip-to-content")}
        </a>
        <Header />
        <main id="main" class="flex-1">
          {slots.default?.()}
        </main>
        <Footer />
      </div>
    );
  },
});
